import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import axios from 'axios';
import {
  PrimaryButton,
  H1ForgotPassword,
  H2ForgotPassword,
  InputBlack
} from '../../components/HelperComponents/StyledComponents';
import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';
import BackgroundImage from '../../images/background.png';
import VoilaConfig from '../../config';
import { addNotification } from '../../actions/ErrorActions';

const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <form onSubmit={handleSubmit}>
    <H1ForgotPassword className="has-text-centered has-text-white is-uppercase">Reset Password</H1ForgotPassword>
    <H2ForgotPassword className="has-text-centered has-text-white">Enter your new password</H2ForgotPassword>
    <div className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent is-rounded has-background-dark"
          placeholder="New Password"
          type="password"
          name="password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password && <p className="help is-danger">{errors.password}</p>}
      </div>
    </div>
    <PrimaryButton className="button is-rounded" style={{ width: '100%' }} type="submit" disabled={isSubmitting}>
      Reset Password
    </PrimaryButton>
  </form>
);

InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

class ResetPasswordComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object
  }

  handleReset = (values, { setSubmitting }) => {
    const params = new URLSearchParams(this.props.location.search);
    const key = params.get('key');
    const login = params.get('login');

    axios.post(`${VoilaConfig.API_URL}/citizen/account/resetpassword`, {
      key,
      login,
      password: values.password
    })
    .then(() => {
      this.props.dispatch(addNotification('Password reset successfully. Please log in.', 'success'));
      this.props.history.push('/');
    })
    .catch(err => {
      this.props.dispatch(addNotification(err.response.data.message, 'danger'));
    })
    .finally(() => setSubmitting(false));
  }

  render() {
    const MyForm = withFormik({
      mapPropsToValues: _props => ({ password: '' }),
      validationSchema: Yup.object({
        password: Yup.string().required('Password is required').min(6, 'Minimum 6 characters')
      }),
      handleSubmit: this.handleReset,
    })(InnerForm);

    const FormStructure = () => (
      <section className="container">
        <section className="columns is-centered">
          <section className="column is-4">
            <MyForm />
          </section>
        </section>
      </section>
    );

    return (
      <Fragment>
        <BulmaHero heroSize="is-fullheight" activateBodyPadding={true} body={<FormStructure />} image={BackgroundImage} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export const ResetPassword = connect(mapStateToProps)(ResetPasswordComponent);


// WEBPACK FOOTER //
// ./src/routes/ResetPassword/ResetPassword.js